(function () {
  function findResumeToken() {
    var prefix = 'otto_cfg_state_v2_';
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var key = localStorage.key(i);
        if (!key || key.indexOf(prefix) !== 0) continue;
        var raw = localStorage.getItem(key);
        if (!raw) continue;
        var data = JSON.parse(raw);
        var token = data && data.selections && data.selections.resume_token;
        if (token) return String(token);
      }
    } catch (_err) {}
    return '';
  }

  function enhanceMealPlanCartLinks() {
    var token = findResumeToken();
    if (!token) return;
    document.querySelectorAll('.otto-meal-plan-cart__link').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href) return;
      try {
        var url = new URL(href, window.location.origin);
        url.searchParams.set('resume', token);
        link.setAttribute('href', url.pathname + url.search);
      } catch (_err) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceMealPlanCartLinks);
  } else {
    enhanceMealPlanCartLinks();
  }
  document.addEventListener('cart-drawer:refreshed', enhanceMealPlanCartLinks);
})();
